module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "member_details"
    }
  }, [(_vm.member) ? _c('div', [_c('div', {
    staticStyle: {
      "min-height": "550px",
      "position": "relative",
      "background-color": "#fff",
      "border-radius": "4px"
    }
  }, [(_vm.member) ? [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "border-bottom": "solid 1px #eee",
      "padding": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-tag', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": (_vm.acceptStatus == 'ACTIVE') ? 'success' : 'info'
    }
  }, [_vm._v("\n\t\t\t\t  \t\t\t" + _vm._s(_vm.acceptStatus) + "\n\t\t\t\t  \t\t")]), _vm._v(" "), _c('h2', [_vm._v("\n\t\t\t\t    \t\t" + _vm._s(_vm.member.user.first_name) + " " + _vm._s(_vm.member.user.last_name) + "\n\t\t\t\t    \t\t"), _c('el-color-picker', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.updateColor
    },
    model: {
      value: (_vm.member.color),
      callback: function($$v) {
        _vm.$set(_vm.member, "color", $$v)
      },
      expression: "member.color"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.member.user.email))])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.member.title))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.addProduct = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.addProduct')))]), _vm._v(" "), (_vm.member.organization_member_products.length == 0) ? _c('el-alert', {
    attrs: {
      "title": "No products found",
      "type": "info",
      "closable": false
    }
  }) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "highlight-current-row": "",
      "data": _vm.member.organization_member_products
    },
    on: {
      "current-change": _vm.selectProduct
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.members.show.table.product.name'),
      "prop": "product.name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.members.show.table.product.price'),
      "prop": "product.price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.members.show.table.product.duration'),
      "prop": "product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t     \t" + _vm._s(scope.row.product.product_configuration.duration) + " mins\n\t\t\t\t\t\t\t\t    ")]
      }
    }], null, false, 59843197)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "small",
          staticStyle: {
            "border-color": "red",
            "background": "red"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteMemberProduct = true;
              _vm.product_delete_id = scope.row.id;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])]
      }
    }], null, false, 2555358561)
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "box-shadow": "0 2px 12px 0 rgba(0,0,0,.1)",
      "border": "1px solid #ebeef5",
      "color": "#303133",
      "border-radius": "4px",
      "padding": "20px"
    }
  }, [(!_vm.selected_product) ? _c('el-alert', {
    attrs: {
      "title": "Please select a product to manage business hours",
      "type": "info",
      "closable": false,
      "center": ""
    }
  }) : [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.selected_product.product.product_configuration.duration) + " mins")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.selected_product.product.name))]), _vm._v(" "), _c('el-collapse', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.setDay
    },
    model: {
      value: (_vm.day),
      callback: function($$v) {
        _vm.day = $$v
      },
      expression: "day"
    }
  }, _vm._l((_vm.days), function(day, index) {
    return _c('el-collapse-item', {
      attrs: {
        "title": day,
        "name": day
      }
    }, [_vm._l((_vm.getHours(_vm.selected_product, day)), function(businesshour) {
      return _c('el-tag', {
        key: businesshour.id,
        attrs: {
          "closable": "",
          "type": "success"
        },
        on: {
          "close": function($event) {
            return _vm.removeHour(businesshour.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t  " + _vm._s(businesshour.start_time) + " - " + _vm._s(businesshour.end_time) + "\n\t\t\t\t\t\t\t\t\t\t")])
    }), _vm._v(" "), (_vm.addTimeVisible) ? _c('div', {
      attrs: {
        "id": "time_selector"
      }
    }, [_c('el-time-select', {
      ref: "saveTagInput",
      refInFor: true,
      staticClass: "input-new-tag",
      attrs: {
        "picker-options": {
          start: '07:00',
          step: _vm.timeslot_gap,
          end: '23:50'
        },
        "prefix-icon": "''",
        "clearable": false,
        "editable": false,
        "placeholder": _vm.$t('static.members.show.options.start')
      },
      on: {
        "blur": _vm.confirmAddTime
      },
      nativeOn: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.confirmAddTime($event)
        }
      },
      model: {
        value: (_vm.start_time),
        callback: function($$v) {
          _vm.start_time = $$v
        },
        expression: "start_time"
      }
    }), _vm._v(" "), _c('el-time-select', {
      ref: "saveTagInput",
      refInFor: true,
      staticClass: "input-new-tag",
      attrs: {
        "picker-options": {
          start: '07:00',
          step: _vm.timeslot_gap,
          end: '23:50'
        },
        "prefix-icon": "''",
        "clearable": false,
        "editable": false,
        "placeholder": _vm.$t('static.members.show.options.end')
      },
      on: {
        "blur": _vm.confirmAddTime
      },
      nativeOn: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.confirmAddTime($event)
        }
      },
      model: {
        value: (_vm.end_time),
        callback: function($$v) {
          _vm.end_time = $$v
        },
        expression: "end_time"
      }
    })], 1) : _c('el-button', {
      staticClass: "button-new-tag small",
      on: {
        "click": function($event) {
          return _vm.showAddHour(index)
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t('static.members.show.addHour')))])], 2)
  }), 1)]], 2)])], 1)] : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border-color": "red",
      "background": "red",
      "position": "absolute",
      "bottom": "15px",
      "left": "15px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteMember = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.deleteMember')))])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('static.members.show.dialog.addProduct.title'),
      "visible": _vm.addProduct,
      "width": "40%"
    },
    on: {
      "close": function($event) {
        _vm.new_product_id = null
      },
      "update:visible": function($event) {
        _vm.addProduct = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "placeholder": "Select product"
    },
    model: {
      value: (_vm.new_product_id),
      callback: function($$v) {
        _vm.new_product_id = $$v
      },
      expression: "new_product_id"
    }
  }, _vm._l((_vm.organization_products), function(product) {
    return _c('el-option', {
      key: product.id,
      attrs: {
        "label": product.name,
        "value": product.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border": "solid 1px #1bbc9b",
      "color": "#1bbc9b",
      "background-color": "#fff",
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.addProduct = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewProduct
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.add')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('static.members.show.dialog.deleteMember.title'),
      "visible": _vm.deleteMember,
      "width": "40%"
    },
    on: {
      "close": function($event) {
        _vm.deleteMember = false;
      },
      "update:visible": function($event) {
        _vm.deleteMember = $event
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.deleteMember.text')) + " "), _c('strong', [_vm._v(_vm._s(_vm.member.user.first_name) + " " + _vm._s(_vm.member.user.last_name))]), _vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border": "solid 1px #1bbc9b",
      "color": "#1bbc9b",
      "background-color": "#fff",
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.deleteMember = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "background-color": "red",
      "border-color": "red"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.confirmDeleteMember
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.delete')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('static.members.show.dialog.deleteMemberProduct.title'),
      "visible": _vm.deleteMemberProduct,
      "width": "40%"
    },
    on: {
      "close": function($event) {
        _vm.deleteMemberProduct = false;
      },
      "update:visible": function($event) {
        _vm.deleteMemberProduct = $event
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.deleteMemberProduct.text')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border": "solid 1px #1bbc9b",
      "color": "#1bbc9b",
      "background-color": "#fff",
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.deleteMemberProduct = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "background-color": "red",
      "border-color": "red"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.confirmDeleteMemberProduct
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.delete')))])], 1)])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8690c4","hasScoped":false}!./src/app/pages/withNavigation/members/show/show.html
// module id = 2928
// module chunks = 1